import ListFieldsGeneric from './ListFieldsGeneric'
let ListFields = ListFieldsGeneric('Person')

export default {
  label: 'Person',
  route: 'person',
  className: 'person', // wird von fob-js-client benutzt
  fields: [
    ListFields.SortableField('titel', true),
    ListFields.SortableField('vorname', true),
    ListFields.SortableField('name', true),
    ListFields.SortableField('fisPersid', false),
    ListFields.UnsortableReference('organisationseinheiten', false),
    ListFields.UnsortableReference('personIdent', true, true)
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/Person.js